export const FETCH_KB = 'FETCH_KB';
export const FETCH_KB_FAILED = 'FETCH_KB_FAILED';
export const FETCH_KB_SUCCESS = 'FETCH_KB_SUCCESS';
export const FETCH_KB_CATEGORIES = 'FETCH_KB_CATEGORIES';
export const FETCH_KB_CATEGORIES_FAILED = 'FETCH_KB_CATEGORIES_FAILED';
export const FETCH_KB_CATEGORIES_SUCCESS = 'FETCH_KB_CATEGORIES_SUCCESS';
export const CREATE_ARTICLE_TRANSLATION_FAILED = 'CREATE_ARTICLE_TRANSLATION_FAILED';